import { IMethodRouter } from 'runtime/methodrouter';
import { RootContainer } from 'runtime/controls/rootcontainer';

export class SubmitCloneRequested {
    static eventName() { return 'SubmitCloneRequested' }
    eventName = SubmitCloneRequested.eventName;

    constructor(public context: RootContainer, public methods: IMethodRouter, public afterSubmit: () => void) { }
}